module.exports = __webpack_public_path__ + "img/file.82d3e1d9.svg";